import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormEmailBlock as Block } from "./FormEmailBlock";
import { defaultData } from "./FormEmailBlockDefaultData";
import { meta } from "./FormEmailBlockMetaData";

export const FormEmailBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-email",
    size: 24,
  },
  meta,
};
